module.exports = __webpack_public_path__ + "static/media/arrow_question_disable.b2209394.svg";